// Iteration 86 — tiny global "is a session playing?" store.
// Written by SessionHost, read by any page (e.g. the Home screen's
// "Return to your session" affordance). Deliberately not React state so it
// survives every route change with zero providers.
let _active = false;
const _listeners = new Set();

export const setSessionActive = (v) => {
  _active = !!v;
  _listeners.forEach((f) => {
    try { f(_active); } catch (e) { /* listener errors never break playback */ }
  });
};

export const isSessionActive = () => _active;

export const subscribeSessionActive = (f) => {
  _listeners.add(f);
  return () => _listeners.delete(f);
};

// WaitingRoom calls this whenever it exits so the host unmounts it.
export const closeHostedSession = () => {
  try { window.dispatchEvent(new Event("continua:session-closed")); } catch (e) { /* ignore */ }
};

// Iter 92 — finer-grained state for the Morning auto-start scheduler: a
// hosted session may still be MOUNTED (ended screen showing at 6:55 AM)
// without actually PLAYING. The scheduler must never interrupt live
// playback, but an ended/idle session view is fair game.
let _playbackEnded = true;
export const setSessionEnded = (v) => { _playbackEnded = !!v; };
export const isSessionPlaying = () => _active && !_playbackEnded;
